import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";
export function Separator(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const t2 = orientation === "horizontal" ? "h-px w-full" : "h-full w-px";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("shrink-0 bg-border", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== orientation || $[8] !== props || $[9] !== t3) {
    t4 = <div role="separator" aria-orientation={orientation} className={t3} {...props} />;
    $[7] = orientation;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}